import { useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { Get } from "utils/request";

const useComments = () => {

    const [page, setPage] = useState(1);
    const [acceptedFilter, setAcceptedFilter] = useState("false");
    const [lessonFilter, setLessonFilter] = useState("all");
    const { id } = useParams();

    const { data, refetch } = useQuery(
        ["courseComments", page, acceptedFilter, lessonFilter],
        async () => await Get(`lessons/files/comments?course=${id}&page=${page}&accepted=${acceptedFilter}&lesson_id=${lessonFilter}&include_all_replies=1`),
        {
        onSuccess: (data) => {
            ;
        },

    });

    const {
        comments,
        lessons,
        pagination: {
            lastPage: maxPage = 1
        } = {}
    } = data || {};

    return {
        comments,
        maxPage,
        page,
        setPage,
        lessons,
        acceptedFilter,
        setAcceptedFilter: (value) => {
            setPage(1);
            setAcceptedFilter(value);
        },
        lessonFilter,
        setLessonFilter: (value) => {
            setPage(1);
            setLessonFilter(value);
        },
        refetch
    };
}

export default useComments;
